import { FC } from 'react'
import { ListRow } from 'src/tailwind-components/extends/List'
import { PlaceholderCell } from 'src/tailwind-components/extends/PlaceholderCell'

type TProps = {
  isMobile: boolean
}

export const TableColumnSkeleton: FC<TProps> = ({ isMobile }) =>
  isMobile ? (
    <ListRow className="grid grid-rows-[20px_84px] gap-2 p-0 text-[rgba(0,0,0,0.72)] shadow-[inset_0_-1px_0_rgba(0,0,0,0.12)]">
      <div className="w-2/5">
        <PlaceholderCell height={20} />
      </div>
      <div className="w-full">
        <PlaceholderCell height={84} />
      </div>
    </ListRow>
  ) : (
    <ListRow className="grid grid-cols-[1fr_1fr_1fr_20px] gap-5 p-0 text-[rgba(0,0,0,0.72)] shadow-[inset_0_-1px_0_rgba(0,0,0,0.12)]">
      <PlaceholderCell height={20} />
      <PlaceholderCell height={20} />
      <PlaceholderCell height={20} />
      <div className="flex size-4 items-center justify-end pr-0">
        <PlaceholderCell height={20} />
      </div>
    </ListRow>
  )
